export default __webpack_public_path__ + "static/media/Group -8.e5ea30e9.png";